import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    '@global': {
      // Default heading tags...
      h1: {
        ...theme.typography.h1,
      },
      h2: {
        ...theme.typography.h2,
      },
      a: {
        color: theme.palette.text.primary,
        ...theme.typography.body1,
      },
      // Scrollbars
      // Works on Firefox
      '*': {
        scrollbarWidth: 'thin',
        scrollbarColor: `${theme.palette.text.secondary} ${theme.palette.secondary.dark}`,
      },
      // Works on Chrome, Edge, and Safari
      '*::-webkit-scrollbar': {
        width: '12px',
      },
      '*::-webkit-scrollbar-track': {
        background: theme.palette.secondary.dark,
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.text.secondary,
        borderRadius: '20px',
        border: `3px solid ${theme.palette.secondary.dark}`,
      },
      // Snackbar
      '#root .SnackbarItem-variantSuccess': {
        color: 'white',
        backgroundColor: theme.palette.success.dark,
        border: '1px solid ' + theme.palette.success.main,
        ...theme.typography.subtitle1,
        '& svg': {
          color: theme.palette.success.main,
          marginRight: 8,
        },
      },
      '#root .SnackbarItem-variantWarning': {
        color: 'white',
        backgroundColor: theme.palette.warning.dark,
        border: '1px solid ' + theme.palette.warning.main,
        ...theme.typography.subtitle1,
        '& svg': {
          color: theme.palette.warning.main,
          marginRight: 8,
        },
      },
      '#root .SnackbarItem-variantError': {
        color: 'white',
        backgroundColor: theme.palette.error.dark,
        border: '1px solid ' + theme.palette.error.main,
        ...theme.typography.subtitle1,
        '& svg': {
          color: theme.palette.error.main,
          marginRight: 8,
        },
      },
      '#root .SnackbarItem-variantInfo': {
        color: 'white',
        backgroundColor: theme.palette.info.dark,
        border: '1px solid ' + theme.palette.info.main,
        ...theme.typography.subtitle1,
        '& svg': {
          color: theme.palette.info.main,
          marginRight: 8,
        },
      },
    },
  }),
);

export default function GlobalStylesHelper() {
  useStyles();
  return <></>;
}
